import { createElement, type ComponentProps } from 'react';
import { Agreements } from '~/source/slices/agreements/agreements.page';
import { Companies } from '~/source/slices/companies/companies.page';
import { Home } from '~/source/slices/home/home.page';
import { Maintenance } from '~/source/slices/maintenance/maintenance.page';
import { Member } from '~/source/slices/member/member.page';
import { Members } from '~/source/slices/members/members.page';
import { Welcome } from '~/source/slices/welcome/welcome.page';
import { SimpleMessages } from '~/source/ui/simple-messages/simple-messages.page';

/** This export is automatically generated. */
export type PageProps =
  | ComponentProps<typeof Agreements>
  | ComponentProps<typeof Companies>
  | ComponentProps<typeof Home>
  | ComponentProps<typeof Maintenance>
  | ComponentProps<typeof Member>
  | ComponentProps<typeof Members>
  | ComponentProps<typeof SimpleMessages>
  | ComponentProps<typeof Welcome>;

/** This export is automatically generated. */
export type PageName =
  | 'Agreements'
  | 'Companies'
  | 'Home'
  | 'Maintenance'
  | 'Member'
  | 'Members'
  | 'SimpleMessages'
  | 'Welcome';

type PageTuples =
  | ['Agreements', ComponentProps<typeof Agreements>]
  | ['Companies', ComponentProps<typeof Companies>]
  | ['Home', ComponentProps<typeof Home>]
  | ['Maintenance', ComponentProps<typeof Maintenance>]
  | ['Member', ComponentProps<typeof Member>]
  | ['Members', ComponentProps<typeof Members>]
  | ['SimpleMessages', ComponentProps<typeof SimpleMessages>]
  | ['Welcome', ComponentProps<typeof Welcome>];

/** This export is automatically generated. */
export const isPageName = (
  input: string
): input is
  | 'Agreements'
  | 'Companies'
  | 'Home'
  | 'Maintenance'
  | 'Member'
  | 'Members'
  | 'SimpleMessages'
  | 'Welcome' => {
  switch (input) {
    case 'Agreements':
    case 'Companies':
    case 'Home':
    case 'Maintenance':
    case 'Member':
    case 'Members':
    case 'SimpleMessages':
    case 'Welcome': {
      return true;
    }
    default: {
      return false;
    }
  }
};

/** This export is automatically generated. */
export const createPage = (
  args: PageTuples
): ReturnType<typeof createElement> => {
  const name = args[0];
  switch (name) {
    case 'Agreements': {
      return createElement(Agreements, args[1]);
    }
    case 'Companies': {
      return createElement(Companies, args[1]);
    }
    case 'Home': {
      return createElement(Home, args[1]);
    }
    case 'Maintenance': {
      return createElement(Maintenance, args[1]);
    }
    case 'Member': {
      return createElement(Member, args[1]);
    }
    case 'Members': {
      return createElement(Members, args[1]);
    }
    case 'SimpleMessages': {
      return createElement(SimpleMessages, args[1]);
    }
    case 'Welcome': {
      return createElement(Welcome, args[1]);
    }
  }
};
